
import { Component, Vue, Ref } from 'vue-property-decorator'
import { MediaService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'media-table',
    components: {
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageIndex = 1
    private pageTotal = 0
    private pageSize = 50
    private list = []
    private userId!: string

    created() {
        this.userId = this.$route.params.id
    }
    mounted() {
        this.getReportToMedia()
    }
    // 向媒体报料
    async getReportToMedia() {
        const params = {
            user_id: this.userId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await MediaService.getReportList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
    }
    _formatStatus(row: any, col: any, value: number) {
        const map = {
            1: '未跟进',
            2: '跟进中',
            3: '跟进完成',
            4: '无需跟进'
        }
        return Reflect.get(map, value)
    }
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getReportToMedia)
    }
}
